const FundTypeEnum = Object.freeze({
    EIS: 'EIS',
    SEIS: 'SEIS',
    SEISEIS: 'SEISEIS',
    IHT: 'IHT',
    OTHER: 'OTHER'
});

export default FundTypeEnum;
